import { motion } from "framer-motion";

const QUOTES = [
    {
        quote:
            "We danced under the mosaics until midnight. The light, the wine, the courtyard — every guest told us it was the most beautiful wedding they had ever attended.",
        author: "Isabella & Marco",
        date: "October 2025",
    },
    {
        quote:
            "López Hill felt like Tuscany met the Hill Country. The team treated our families like their own. We are still receiving texts months later.",
        author: "Sarah & David",
        date: "May 2025",
    },
    {
        quote:
            "An art gallery, a courtyard, a tequila tasting for the groomsmen — our weekend was a series of unforgettable moments.",
        author: "Camila & Ethan",
        date: "March 2025",
    },
];

export default function Testimonials() {
    return (
        <section
            className="section-py container-px bg-[hsl(var(--foreground))] text-[hsl(var(--background))] relative"
            data-testid="testimonials-section"
        >
            <p className="overline text-[hsl(var(--accent))]">Words from our couples</p>

            <div className="mt-12 grid lg:grid-cols-3 gap-12 lg:gap-16">
                {QUOTES.map((q, i) => (
                    <motion.figure
                        key={q.author}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: i * 0.1 }}
                        viewport={{ once: true, margin: "-50px" }}
                        className="flex flex-col gap-8"
                        data-testid={`testimonial-${i}`}
                    >
                        <span className="font-serif italic text-[hsl(var(--accent))] text-6xl leading-none">
                            &ldquo;
                        </span>
                        <blockquote className="font-serif font-light text-2xl sm:text-3xl leading-[1.25] tracking-tight">
                            {q.quote}
                        </blockquote>
                        <figcaption className="pt-6 border-t border-white/15">
                            <div className="text-sm tracking-[0.2em] uppercase">{q.author}</div>
                            <div className="mt-1 text-xs text-white/60">{q.date}</div>
                        </figcaption>
                    </motion.figure>
                ))}
            </div>
        </section>
    );
}
